import { useQuery } from '@tanstack/react-query';
import { IResourcePlannerTotalResult } from '@legacy/apis/types/resourcePlannerAPI';
import { IFilterStoreProps } from '@legacy/reducers/FilterReducer';
import { postFetch } from '@legacy/utils/fetcher';
import { GROUP_BY_RESOURCE_TOTAL_KEY } from '../constants';
import { getFiltersParam, getQueryParams } from '../utils';

const GROUP_BY_RESOURCE_TOTAL_URL_PATH =
  '/api/v2/resource-planner/group-by-employee-total-row';

const resourcePlannerFetch = (
  filters: string,
  params: Record<string, string>,
): Promise<IResourcePlannerTotalResult> =>
  postFetch({
    path: `${GROUP_BY_RESOURCE_TOTAL_URL_PATH}${getQueryParams(params)}`.concat(
      filters,
    ),
    key: GROUP_BY_RESOURCE_TOTAL_KEY,
  });

interface IUseGetGroupByResourceTotal {
  params: Record<string, string>;
  selectedFilterList: IFilterStoreProps['selectedFilterList'];
}

export const useGetGroupByResourceTotal = ({
  params,
  selectedFilterList,
}: IUseGetGroupByResourceTotal) => {
  const filtersParam = getFiltersParam(selectedFilterList);

  const { data, isError, ...restProps } = useQuery({
    queryFn: () => resourcePlannerFetch(filtersParam, params),
    queryKey: [GROUP_BY_RESOURCE_TOTAL_KEY, params, selectedFilterList],
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    ...restProps,
  };
};
